<div class="main-container">
  <app-embedded-loader [show]="showLoader"></app-embedded-loader>

  <app-buyer-supplier-chat
    [headerData]="headerData"
    [isOpen]="isChatOpen"
    [rfqId]="headerData?.rfqId"
    [userId]="userIdAsString"
    [isSupplier]="userRole === 'Suppliers'"
    (close)="closeChat()"
  ></app-buyer-supplier-chat>
 
  <div class="title-text">Pending Purchase Order Approval </div>
  <div class="section">
    <div class="search-filter-container">
      <div class="search-container">
        <input
          type="text"
          [(ngModel)]="searchParam"
          placeholder="Search on PO Number and Keywords"
          class="search-input"
        />
        <button class="search-button" (click)="onSearch()">
          <mat-icon>search</mat-icon> Search
        </button>
      </div>
      <div class="search-filter-content">
        <mat-form-field class="date-field" appearance="fill">
          <mat-label>From Date</mat-label>
          <input
            matInput
            [matDatepicker]="fromDatepicker"
            placeholder="DD/MM/YYYY"
            [(ngModel)]="fromDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="fromDatepicker"
            [disabled]="false"
          ></mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #fromDatepicker></mat-datepicker>

        <mat-form-field class="date-field" appearance="fill">
          <mat-label>To Date</mat-label>
          <input
            matInput
            [matDatepicker]="toDatepicker"
            placeholder="DD/MM/YYYY"
            [(ngModel)]="toDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="toDatepicker"
            [disabled]="false"
          ></mat-datepicker-toggle>
        </mat-form-field>
        <mat-datepicker #toDatepicker></mat-datepicker>
        <div class="search-filter-button-container">
          <button type="submit" class="search-btn" (click)="onSearch()">
            <mat-icon>search</mat-icon>
          </button>
          <button type="button" class="close-button" (click)="cancelFilter()">
            <mat-icon>cancel</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="filter-statuses">
      <button
        *ngFor="let status of filterStatuses; let i = index"
        class="status-btn"
        [ngClass]="{ active: activeIndex === i }"
        (click)="onStatusSelect(status.name, i, status.label)"
        matTooltip="{{ status.label }}"
      >
        {{ status.name }}
      </button>
    </div>

    <div
      class="filter-section"
      style="display: flex; align-items: center"
      *ngIf="this.selectedPO.length > 0"
    >
      <div style="margin-left: 20px">
        <b
          >Selected {{ this.selectedPO.length }} of
          {{ this.totalRecords }} POs</b
        >
      </div>

      <button
        style="position: relative; bottom: 3px"
        mat-icon-button
        mat-sm-button
        color="primary"
        class="mr-1"
        matTooltipClass="mat-tooltip-custom"
        matTooltip="Archive"
        matTooltipPosition="below"
        (click)="purchaseOrderOperation('archiveAPO')"
      >
        <mat-icon>archive</mat-icon>
      </button>
    </div>

    <div class="dropdown-container-active">
      <div class="text-right" style="display: inline-flex; align-items: center">
        <button
          mat-mini-fab
          matTooltip="Export All"
          matTooltipPosition="below"
          (click)="exportAllPOs()"
        >
          <mat-icon
            matTooltipClass="mat-tooltip-custom"
            svgIcon="downloadExcel"
          ></mat-icon>
        </button>
        <!-- <span style="font-size: 16px;font-weight: bolder;margin-left:5px">Export All</span> -->
      </div>
      <div
        style="
          width: 7%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div class="invitebutton-container">
          <!-- Button to trigger the user invite menu -->
          <button
            class="circle-button"
            [matMenuTriggerFor]="usermenu"
            matTooltip="Invite User"
            (click)="alreadyAssignedBuyerUsers()"
          >
            <mat-icon class="icon-person"> person_add </mat-icon>
          </button>

          <!-- Menu for inviting users with fixed height and scrollable -->
          <mat-menu #usermenu="matMenu" id="usermenu">
            <!-- Menu content container with scroll event -->
            <div class="menu-content" (scroll)="onScroll()">
              <!-- User list displayed inside the menu with checkboxes for selection -->
              <button
                mat-menu-item
                *ngFor="let item of buyerUsersList"
                (click)="toggleUserSelection(item)"
              >
                <mat-checkbox [checked]="item.selected">{{
                  item.firstName
                }}</mat-checkbox>
              </button>

              <!-- Spinner or loading indicator when fetching more users -->
              <mat-progress-spinner
                *ngIf="isLoading"
                mode="indeterminate"
                diameter="20"
              ></mat-progress-spinner>
            </div>
          </mat-menu>
        </div>
        <div>
          <button
            mat-fab
            class="green-button"
            [matMenuTriggerFor]="menu"
            matTooltip="Show more columns"
          >
            <mat-icon style="position: relative; right: -3px"
              >playlist_add</mat-icon
            >
          </button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              *ngFor="let item of items"
              (click)="toggleSelection(item)"
            >
              <mat-checkbox [checked]="item.selected">{{
                item.label
              }}</mat-checkbox>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>

    <div class="active-table-container">
      <ngx-datatable
        style="border-radius: 5px"
        #supplierTable
        class="material expandable bg-light supplier-table sup-tbl"
        [rows]="documentData"
        [headerHeight]="50"
        [footerHeight]="50"
        [rowHeight]="'auto'"
        [columnMode]="'force'"
        [limit]="limit"
        [count]="totalRecords"
        [externalPaging]="true"
        [externalSorting]="true"
        [scrollbarH]="false"
        [offset]="offset"
        (page)="onPageChange($event)"
        (sort)="onSort($event)"
        [rowClass]="setRowClass"
      >
        
        <ngx-datatable-column name="PO Number" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <!-- <span
              class="PO-Number"
              matTooltip="{{ row.purchaseOrderRefNumber }}"
              matTooltipPosition="below"
              (click)="openRfqDetails(row.rfqDetailsId)"
              >{{ row.purchaseOrderRefNumber }}</span
            > -->
            <span
              class="PO-Number"
              matTooltip="{{ row.purchaseOrderRefNumber }}"
              matTooltipPosition="below"
              >{{ row.purchaseOrderRefNumber }}</span
            >
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="RFQ Reference" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <!-- <span
              class="rfq-reference"
              matTooltip="{{ row.rfqRefNumber }}"
              matTooltipPosition="below"
              (click)="openRfqDetails(row.rfqDetailsId)"
              >{{ row.rfqRefNumber }}</span
            > -->
            <span
              class="rfq-reference"
              matTooltip="{{ row.rfqRefNumber }}"
              matTooltipPosition="below"
              >{{ row.rfqRefNumber }}</span
            >
          </ng-template>
        </ngx-datatable-column>


        <ngx-datatable-column name="Quote Number" [flexGrow]="1">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <!-- <span
              class="quote-number"
              matTooltip="{{ row.quoteRefNumber }}"
              matTooltipPosition="below"
              (click)="openRfqDetails(row.rfqDetailsId)"
              >{{ row.quoteRefNumber}}</span
            > -->
            <span
              class="quote-number"
              matTooltip="{{ row.quoteRefNumber }}"
              matTooltipPosition="below"
              >{{ row.quoteRefNumber}}</span
            >
          </ng-template>
        </ngx-datatable-column>

        <!-- vessel Name -->
        <ngx-datatable-column name="Vessel" [flexGrow]="0.6">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="Vessel"
              matTooltip="{{ row.vesselName }}"
              matTooltipPosition="below"
              >{{ row.vesselName }}</span
            >
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Port Name" [flexGrow]="0.7">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="Port Name"
              matTooltip="{{ row.portName }}"
              matTooltipPosition="below"
              >{{ row.portName }}</span
            >
          </ng-template>
        </ngx-datatable-column>


        <ngx-datatable-column name="Supplier Name" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <!-- <span>{{ row.suppliers?.length || 0 }}</span> -->
              <span>{{ row.supplierName }}</span>
            </ng-template>
          </ngx-datatable-column>

        <ngx-datatable-column name="Amount" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
            <span>{{ row.totalCost }} {{row.currencyCode}}</span>
            </ng-template>
        </ngx-datatable-column>


       
        <!-- Status with Expand -->
        <ngx-datatable-column name="Status" [minWidth]="150" [flexGrow]="0.8">
          <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
            
            <div class="status-wrapper">
              <span
                class="status-pill"
                matTooltip="{{ row.approvalStatus }}"
                matTooltipPosition="below"
                [ngStyle]="{ color: getStatusColor(row.approvalStatus) }"
              >
                {{ row.approvalStatus }}
              </span>

              <mat-icon
                class="expand-icon"
                style="cursor: pointer;"
                (click)="toggleExpandedRow(row, rowIndex, supplierTable)"
                matTooltip="View Approval Details"
              >
                {{ expandedRowId === row.purchaseOrderId ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </div>

          </ng-template>
        </ngx-datatable-column>


        <ngx-datatable-column name="Owner" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                matTooltip="{{
                    row.buyerUserName ? row.buyerUserName : row.buyerName
                    }}"
                matTooltipPosition="below"
              >{{ row.buyerUserName || row.buyerName }}</span>
            </ng-template>
          </ngx-datatable-column>


        <ngx-datatable-column
          *ngFor="let column of selectedColumns"
          [name]="column.label"
          [flexGrow]="1"
        >
          <ng-template let-row="row" ngx-datatable-cell-template>
            
            <!-- <span *ngIf="column.label === 'Owner'">
              <span
                matTooltip="{{
                  row.buyerUserName ? row.buyerUserName : row.buyerName
                }}"
                matTooltipPosition="below"
              >
                {{ row.buyerUserName || row.buyerName }}
              </span>
            </span> -->

            
            <span>
              <span
                *ngIf="isDate(row[column.prop])"
                matTooltip="{{ row[column.prop] | date : 'dd/MM/yyyy' : '-' }}"
                matTooltipPosition="below"
              >
                {{ row[column.prop] | date : "dd/MM/yyyy" : "-" }}
              </span>
              <span
                *ngIf="!isDate(row[column.prop])"
                matTooltip="{{ row[column.prop] || '-' }}"
                matTooltipPosition="below"
              >
                {{ row[column.prop] || "-" }}
              </span>
            </span>
          </ng-template>
        </ngx-datatable-column>

        <!-- <ngx-datatable-column name="Action" [minWidth]="100" [flexGrow]="2">
          <ng-template let-column="column" ngx-datatable-header-template
            ><span>Action</span>
          </ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
           
            <button
              *ngIf="row.docStatus !== 'Canceled'"
              mat-icon-button
              mat-sm-button
              style="position: relative; bottom: 16px"
              color="primary"
              class="mr-1"
              matTooltipClass="mat-tooltip-custom"
              (click)="openRfqDetails(row.rfqId)"
              matTooltip="Open"
              matTooltipPosition="below"
            >
              <mat-icon>edit</mat-icon>
            </button>

            <button
              *ngIf="row.docStatus !== 'Canceled'"
              mat-icon-button
              mat-sm-button
              style="position: relative; bottom: 16px"
              color="primary"
              class="mr-1"
              matTooltipClass="mat-tooltip-custom"
              (click)="openCancellationBox(row.rfqId)"
              matTooltip="Cancel RFQ"
              matTooltipPosition="below"
            >
              <mat-icon class="color-red">cancel</mat-icon>
            </button>
          </ng-template>
        </ngx-datatable-column> -->


       <!-- <ngx-datatable-column name="Action" [minWidth]="100" [flexGrow]="1">
          <ng-template let-column="column" ngx-datatable-header-template
            ><span>Action</span>
          </ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <button
                mat-raised-button
                *ngIf="row.approvalStatus === 'Approved'"
                color="primary"
                class="send-po-btn"
                style="background-color: #1F7E3F;"
                (click)="row.purchaseOrderStatus !== 3 && sendPO(row)"
            >
                {{ row.purchaseOrderStatus === 3 ? 'PO Sent' : 'Send PO' }}
            </button>
            <button
              *ngIf="row.isApprover === 1"
              mat-icon-button
              mat-sm-button
              style="position: relative; bottom: 16px"
              color="primary"
              class="mr-1"
              matTooltipClass="mat-tooltip-custom"
              (click)="openPoDetails(row)"
              matTooltip="Open"
              matTooltipPosition="below"
            >
              <mat-icon>edit</mat-icon>
            </button>

          </ng-template>
        </ngx-datatable-column> -->
        

        <ngx-datatable-column name="Action" [minWidth]="100" [flexGrow]="1">
  <ng-template let-column="column" ngx-datatable-header-template>
    <span>Action</span>
  </ng-template>
  <ng-template let-row="row" ngx-datatable-cell-template>
    <div style="display: flex; justify-content: flex-start; align-items: center;">
      <button
        mat-raised-button
        *ngIf="row.approvalStatus === 'Approved'"
        color="primary"
        class="send-po-btn"
        style="background-color: #1F7E3F; margin-right: 2px; padding: 6px 16px; white-space: nowrap; font-size: 12px;"
        (click)="row.purchaseOrderStatus !== 3 && sendPO(row)"
      >
        {{ row.purchaseOrderStatus === 3 ? 'PO Sent' : 'Send PO' }}
      </button>
      <button
        *ngIf="row.isApprover === 1"
        mat-icon-button
        mat-sm-button
        color="primary"
        class="mr-1"
        style="margin-left: 2px; font-size: 18px;"  
        matTooltipClass="mat-tooltip-custom"
        (click)="openPoDetails(row)"
        matTooltip="Open"
        matTooltipPosition="below"
      >
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  </ng-template>
</ngx-datatable-column>

        <ngx-datatable-column
          [sortable]="false"
          [maxWidth]="55"
          [minWidth]="55"
        >
          <ng-template ngx-datatable-header-template>
            <input
              type="checkbox"
              [checked]="this.selectedPO.length == this.documentData.length"
              (change)="toggleSelectAll($event, 'active')"
            />
          </ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            <!-- <input type="checkbox" [checked]="isChecked(row.rfqId,'active')"
                        (change)="selectDeselectRfq($event, row.rfqId,'active',row.owner)" /> -->
            <input
              type="checkbox"
              [checked]="isChecked(row.purchaseOrderId, 'active')"
              (change)="
                selectDeselectPO(
                  $event,
                  row.purchaseOrderId,
                  row.purchaseOrderId,
                  'active',
                  row.buyerUserName
                )
              "
            />
          </ng-template>
        </ngx-datatable-column>


        <!-- <ngx-datatable-row-detail 
          [rowHeight]="getRowHeight"
          #rowDetail
        >
          <ng-template let-row="row" ngx-datatable-row-detail-template>
            <div class="approval-details-wrapper" style="padding: 10px; background: #f9f9f9; border-radius: 5px;">
              <table class="approval-table" style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr style="background: #eee;">
                    <th>Approver</th>
                    <th>Department</th>
                    <th>Action</th>
                    <th>Date</th>
                    <th>Comment</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let approver of row.approvalDetails">
                    <td>{{ approver.approverName }}</td>
                    <td>{{ approver.department || '-' }}</td>
                    <td
                      [ngStyle]="{
                        color: approver.approverStatus === 'Approved' ? 'green' :
                              approver.approverStatus === 'Rejected' ? 'red' : '#555'
                      }"
                    >
                      {{ approver.approverStatus || '-' }}
                    </td>
                    <td>{{ approver.approvalCreatedAt ? (approver.approvalCreatedAt | date:'dd-MM-yyyy') : '-' }}</td>
                    <td>{{ approver.approverComments || '-' }}</td>
                    <td
                      [ngStyle]="{
                        color: approver.approverStatus === 'Approved' ? 'green' :
                              approver.approverStatus === 'Rejected' ? 'red' : '#555'
                      }"
                    >
                      {{ approver.approverStatus || '-' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-template>
        </ngx-datatable-row-detail> -->


        <ngx-datatable-row-detail [rowHeight]="getRowHeight" #rowDetail>
          <ng-template let-row="row" ngx-datatable-row-detail-template>
            <div class="approval-details-wrapper" style="padding: 10px; background: #f9f9f9; border-radius: 5px;max-height: 210px; overflow-y: auto;">
              <table class="approval-table" style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr style="background: #eee;">
                    <th>{{row.approvalLevel}}</th>
                    <th>Department</th>
                    <th>Action</th>
                    <th>Date</th>
                    <th>Comment</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let approver of row.approvalDetails">
                    <td>{{ approver.approverName }}</td>
                    <td>{{ approver.department || '-' }}</td>
                    <!-- <td>{{ approver.approverStatus || 'Pending' || '-' }}</td> -->
                     <td
                        [ngStyle]="{
                          color:
                            approver.approverStatus === 'Approved'
                              ? '#07AB07'
                              : approver.approverStatus === 'Rejected'
                              ? '#FF0000'
                              : '#ff9800'
                        }"
                      >
                        {{ approver.approverStatus || 'Pending' }}
                      </td>
                    <td>{{ approver.approvalCreatedAt ? (approver.approvalCreatedAt | date:'dd-MM-yyyy') : '-' }}</td>
                    <td>{{ approver.approverComments || '-' }}</td>
                    <!-- <td>{{ approver.approverStatus || 'Pending' || '-' }}</td> -->
                     <td
                        [ngStyle]="{
                          color:
                            approver.approverStatus === 'Approved'
                              ? '#07AB07'
                              : approver.approverStatus === 'Rejected'
                              ? '#FF0000'
                              : '#ff9800'
                        }"
                      >
                        {{ approver.approverStatus || 'Pending' }}
                      </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-template>
        </ngx-datatable-row-detail>

      </ngx-datatable>
    </div>

    <div class="archive-container" #heading>
      <span
        style="
          padding-left: 16px;
          padding-top: 16px;
          margin-bottom: 20px;
          font-weight: bold;
          display: flex;
          justify-content: space-between;
          padding-right: 20px;
        "
        (click)="toggleArchived()"
      >
        <div style="display: inline-flex; align-items: center">
          <span style="margin-left: 4px">Archived Documents</span>
        </div>

        <mat-icon>
          {{ isArchivedExpand ? "expand_less" : "expand_more" }}
        </mat-icon>
      </span>

      <ng-container *ngIf="isArchivedExpand">
        <!-- <div
          class="filter-section-selection-container"
          style="display: flex; align-items: center"
          *ngIf="this.selectedArchivedPO.length > 0"
        >
          <div style="margin-left: 10px">
            <b
              >Selected {{ this.selectedArchivedPO.length }} of
              {{ this.archivedTotalRecords }} archived POs</b
            >
          </div>

          <button
            style="position: relative; bottom: 3px"
            mat-icon-button
            mat-sm-button
            color="primary"
            class="mr-1"
            matTooltipClass="mat-tooltip-custom"
            matTooltip="Urchive"
            matTooltipPosition="below"
            (click)="purchaseOrderOperation('unarchive')"
          >
            <mat-icon>unarchive</mat-icon>
          </button>
        </div> -->

        <div class="dropdown-container">
          <button
            mat-fab
            class="green-button"
            [matMenuTriggerFor]="archivedMenu"
            matTooltip="Show more columns"
          >
            <mat-icon style="position: relative; right: -3px"
              >playlist_add</mat-icon
            >
          </button>
          <mat-menu #archivedMenu="matMenu">
            <button
              mat-menu-item
              *ngFor="let item of archivedItems"
              (click)="archivedToggleSelection(item)"
            >
              <mat-checkbox [checked]="item.selected">{{
                item.label
              }}</mat-checkbox>
            </button>
          </mat-menu>
        </div>

        <ngx-datatable
          style="border-radius: 5px"
          #archivedSection
          #supplierTable
          class="material expandable bg-light supplier-table sup-tbl"
          [rows]="archivedDocumentData"
          [headerHeight]="50"
          [footerHeight]="50"
          [rowHeight]="'auto'"
          [columnMode]="'force'"
          [limit]="limit"
          [count]="archivedTotalRecords"
          [externalPaging]="true"
          [externalSorting]="true"
          [scrollbarH]="false"
          [offset]="archivedOffset"
          (page)="onArchivedPageChange($event)"
          (sort)="onSort($event)"
          [rowClass]="setRowClass"
        >
          <ngx-datatable-column name="PO Number" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <!-- <span
                class="PO-Number"
                matTooltip="{{ row.purchaseOrderRefNumber }}"
                matTooltipPosition="below"
                (click)="openRfqDetails(row.rfqDetailsId)"
                >{{ row.purchaseOrderRefNumber }}</span
              > -->
              <span
                class="PO-Number"
                matTooltip="{{ row.purchaseOrderRefNumber }}"
                matTooltipPosition="below"
                >{{ row.purchaseOrderRefNumber }}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="RFQ Reference" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <!-- <span
                class="rfq-reference"
                matTooltip="{{ row.rfqRefNumber }}"
                matTooltipPosition="below"
                (click)="openRfqDetails(row.rfqDetailsId)"
                >{{ row.rfqRefNumber }}</span
              > -->
              <span
                class="rfq-reference"
                matTooltip="{{ row.rfqRefNumber }}"
                matTooltipPosition="below"
                >{{ row.rfqRefNumber }}</span
              >
            </ng-template>
          </ngx-datatable-column>


          <ngx-datatable-column name="Quote Number" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <!-- <span
                class="quote-number"
                matTooltip="{{ row.quoteRefNumber }}"
                matTooltipPosition="below"
                (click)="openRfqDetails(row.rfqDetailsId)"
                >{{ row.quoteRefNumber}}</span
              > -->
              <span
                class="quote-number"
                matTooltip="{{ row.quoteRefNumber }}"
                matTooltipPosition="below"
                >{{ row.quoteRefNumber}}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <!-- vessel Name -->
          <ngx-datatable-column name="Vessel" [flexGrow]="0.6">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="Vessel"
                matTooltip="{{ row.vesselName }}"
                matTooltipPosition="below"
                >{{ row.vesselName }}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="Port Name" [flexGrow]="0.7">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <span
                class="Port Name"
                matTooltip="{{ row.portName }}"
                matTooltipPosition="below"
                >{{ row.portName }}</span
              >
            </ng-template>
          </ngx-datatable-column>


          <ngx-datatable-column name="Supplier Name" [flexGrow]="1">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <!-- <span>{{ row.suppliers?.length || 0 }}</span> -->
                <span>{{ row.supplierName }}</span>
              </ng-template>
            </ngx-datatable-column>

          <ngx-datatable-column name="Amount" [flexGrow]="1">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <span>{{ row.totalCost }}{{ row.currencyCode }}</span>
              </ng-template>
            </ngx-datatable-column>

          <!-- Status -->
          <ngx-datatable-column name="Status" [minWidth]="150" [flexGrow]="0.8">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span
              class="status-pill"
              matTooltip="{{
                row.approvalStatus
              }}"
              matTooltipPosition="below"
              [ngStyle]="{ color: getStatusColor(row.approvalStatus) }"
            >
              {{ row.approvalStatus }}
            </span>
          </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Owner" [flexGrow]="1">
                <ng-template let-row="row" ngx-datatable-cell-template>
                <span
                    matTooltip="{{
                        row.buyerUserName ? row.buyerUserName : row.buyerName
                        }}"
                    matTooltipPosition="below"
                >{{ row.buyerUserName || row.buyerName }}</span>
                </ng-template>
            </ngx-datatable-column>



        <ngx-datatable-column
          *ngFor="let column of archivedSelectedColumns"
          [name]="column.label"
          [flexGrow]="1"
        >
          <ng-template let-row="row" ngx-datatable-cell-template>
            
            <span>
              <span
                *ngIf="isDate(row[column.prop])"
                matTooltip="{{ row[column.prop] | date : 'dd/MM/yyyy' : '-' }}"
                matTooltipPosition="below"
              >
                {{ row[column.prop] | date : "dd/MM/yyyy" : "-" }}
              </span>
              <span
                *ngIf="!isDate(row[column.prop])"
                matTooltip="{{ row[column.prop] || '-' }}"
                matTooltipPosition="below"
              >
                {{ row[column.prop] || "-" }}
              </span>
            </span>
          </ng-template>
        </ngx-datatable-column>

          <!-- Restore Action -->

          <ngx-datatable-column name="Action" [flexGrow]="1">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <button
                class="popover_delete"
                [mdePopoverTriggerFor]="appPopover"
                mdePopoverTriggerOn="click"
                [mdePopoverBackdropCloseOnClick]="false"
                mat-icon-button
                #popoverTrigger="mdePopoverTrigger"
              >
                <mat-icon
                  matTooltipClass="mat-tooltip-custom"
                  matTooltip="Restore"
                  matTooltipPosition="below"
                  >restore</mat-icon
                >
              </button>

              <mde-popover
                #appPopover="mdePopover"
                [mdePopoverOverlapTrigger]="false"
              >
                <mat-card class="mat-card-popover popover-card">
                  <mat-card-header class="mat-card-header-popover">
                    <mat-card-title class="popover-title"
                      >Are you sure?</mat-card-title
                    >
                  </mat-card-header>
                  <mat-card-actions
                    class="mat-card-action-popover popover-actions"
                  >
                    <button
                      class="mat-action-btn popover_action cancel"
                      mat-raised-button
                      (click)="popoverTrigger.togglePopover()"
                    >
                      Cancel
                    </button>
                    <button
                      class="mat-action-btn popover_action restore"
                      mat-raised-button
                      color="warn"
                      (click)="RestorePo(true, row)"
                    >
                      Restore
                    </button>
                  </mat-card-actions>
                </mat-card>
              </mde-popover>
            </ng-template>
          </ngx-datatable-column>

          
        </ngx-datatable>
      </ng-container>
    </div>

    <!-- Popup for confirmation -->

    <div class="namemodal" *ngIf="showConfirmationDialogue">
      <div class="modalContent">
        <div class="p-6 text-center">
          <div class="flex justify-center mb-4">
            <div
              class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center"
            >
              <mat-icon
                class="text-orange-600"
                style="font-size: 40px; height: 100%; width: 100%"
                >warning</mat-icon
              >
            </div>
          </div>
          <h2 class="text-xl font-bold mb-2">Are you sure?</h2>
          <p class="mb-6">
            Are you sure you want to cancel this request for quotation?<br />Select
            a reason from the dropdown
          </p>
          <mat-form-field class="full-width" color="accent">
            <mat-label>Cancel reason</mat-label>
            <mat-select [(ngModel)]="cancelReason">
              <mat-option value="No Longer Needed">
                No Longer Needed</mat-option
              >
              <mat-option value="Duplicate RFQ"> Duplicate RFQ</mat-option>
              <mat-option value="Error in the RFQ Details">
                Error in the RFQ Details</mat-option
              >
              <mat-option value="Supplier Information not available">
                Supplier Information not available</mat-option
              >

              <mat-option value="Other"> Other</mat-option>
            </mat-select>
          </mat-form-field>
          <!-- Input field for custom reason when "Other" is selected -->
          <mat-form-field
            *ngIf="cancelReason === 'Other'"
            class="full-width"
            color="accent"
          >
            <mat-label>Specify the reason</mat-label>
            <input
              matInput
              [(ngModel)]="customReason"
              placeholder="Please specify"
            />
          </mat-form-field>
          <div class="flex justify-center gap-4">
            <button
              mat-raised-button
              color="primary"
              (click)="save(true)"
              [disabled]="
                cancelReason == '' ||
                (cancelReason === 'Other' && customReason.trim() === '')
              "
            >
              Yes, Cancel
            </button>
            <button mat-stroked-button (click)="cancel()">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
